export const urlUtils = {
  // Validate if a string is a valid URL
  isValidURL(string) {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  },

  // Extract domain from URL
  extractDomain(url) {
    try {
      const urlObj = new URL(url);
      return urlObj.hostname.replace('www.', '');
    } catch (_) {
      return '';
    }
  },

  // Fetch page title from URL
  async fetchPageTitle(url) {
    try {
      // Since we can't directly fetch due to CORS, we'll use a proxy service
      // or extract from user input. For now, return a simple title.
      const domain = this.extractDomain(url);
      return `Bookmark from ${domain}`;
    } catch (error) {
      console.error('Error fetching page title:', error);
      return 'Bookmark';
    }
  },

  // Check clipboard for URL
  async checkClipboard() {
    try {
      if (!navigator.clipboard) {
        return null;
      }
      const clipboardText = await navigator.clipboard.readText();
      if (this.isValidURL(clipboardText)) {
        return clipboardText.trim();
      }
      return null;
    } catch (error) {
      // Clipboard access denied or not available
      return null;
    }
  },

  // Format URL (add https if missing)
  formatURL(url) {
    if (!url) return '';
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return `https://${url}`;
    }
    return url;
  }
};
